import type { Role } from '@/models';

/**
 * Matches Spatie / API role names for sales representative (spacing/casing tolerant).
 */
export function isSalesRepresentativeRole(role: Role | undefined): boolean {
  if (!role?.name) {
    return false;
  }
  return role.name.replace(/\s+/g, '').toLowerCase() === 'salesrepresentative';
}

/**
 * Query string for get-companies: assigned merchants only for sales reps; empty for everyone else (e.g. SuperAdmin).
 */
export function buildGetCompaniesQueryString(role: Role | undefined): string {
  if (!isSalesRepresentativeRole(role)) {
    return '';
  }
  const params = new URLSearchParams({
    role: 'salesRepresentative',
    company_scope: 'assigned',
  });
  return `?${params.toString()}`;
}
